import WarningIcon from '@mui/icons-material/Warning';
import CheckIcon from '@mui/icons-material/Check';
import ACCOUNT_STATUS from './ACCOUNT_STATUS';
import React from 'react';
import { Typography } from '@material-ui/core';
import MuiTableCell from '@material-ui/core/TableCell';

export const AccountStatusWarningIcon = props => <WarningIcon {...props} color="warning" />;

export const getAccountStatusCellValues = account_status => {
  const icon = account_status > 0 ? AccountStatusWarningIcon : CheckIcon;
  const text = {
    [ACCOUNT_STATUS.NO_ACCOUNT]: 'No stripe account',
    [ACCOUNT_STATUS.LINKED]: 'Stripe account linked',
    [ACCOUNT_STATUS.REQUIRES_INFO]: 'Stripe requires more info',
  }[account_status];

  return {
    icon,
    text,
  };
};

const AccountStatusCell = ({ row, ...rest }) => {
  const { icon: AccountStatusIcon, text: accountStatusText } = getAccountStatusCellValues(row.payment_account_status);

  return (
    <MuiTableCell {...rest}>
      <Typography>
        <AccountStatusIcon fontSize={'small'} /> {accountStatusText}
      </Typography>
    </MuiTableCell>
  );
};

export default AccountStatusCell;
